export default function ({ app, $gtm }) {
  if (process.server) {
    return
  }
  $gtm.init(app.i18n.localeProperties.gtmContainerId)
}
